import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';

// ══════════════════════════════════════════════════════════════════════════════
// SİLME ONAY MODALI
// ══════════════════════════════════════════════════════════════════════════════
function DeleteConfirmModal({ isOpen, onClose, onConfirm, title, message, loading }) {
  if (!isOpen) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ borderBottom: '1px solid var(--border)' }}>
          <div className="modal-title" style={{ color: '#EF4444' }}>🗑️ {title || 'Silme Onayı'}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div style={{ padding: '20px 24px' }}>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 24 }}>
            {message || 'Bu kaydı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'}
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button className="btn btn-ghost" onClick={onClose} disabled={loading}>İptal</button>
            <button
              className="btn btn-danger"
              onClick={onConfirm}
              disabled={loading}
              style={{ background: '#EF4444', color: 'white', border: 'none' }}
            >
              {loading ? 'Siliniyor...' : '🗑️ Evet, Sil'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// MOBİL UYUMLULUK STİLLERİ
// ══════════════════════════════════════════════════════════════════════════════
const mobileStyles = `
  @media (max-width: 768px) {
    .table-wrapper, .mobile-scroll-x {
      overflow-x: hidden !important; 
      display: block !important;
    }
    .mobile-table-card {
      display: block !important;
      border: none !important;
    }
    .mobile-table-card thead {
      display: none !important;
    }
    .mobile-table-card tbody,
    .mobile-table-card tr {
      display: block !important;
      width: 100% !important;
    }
    .mobile-table-card tr {
      background: var(--bg-card, #fff) !important;
      border: 1px solid var(--border) !important;
      border-radius: 12px !important;
      margin-bottom: 16px !important;
      padding: 8px !important;
      box-shadow: 0 2px 5px rgba(0,0,0,0.05) !important;
    }
    .mobile-table-card td {
      display: flex !important;
      justify-content: space-between !important;
      align-items: center !important;
      text-align: right !important;
      padding: 10px 12px !important;
      border-bottom: 1px solid var(--border-light, #f1f5f9) !important;
      width: 100% !important;
      box-sizing: border-box !important;
    }
    .mobile-table-card td::before {
      content: attr(data-label) !important;
      font-weight: 700 !important;
      color: var(--text-muted, #64748b) !important;
      text-align: left !important;
      font-size: 0.8rem !important;
      flex: 1 !important;
    }
    .mobile-table-card td:last-child {
      border-bottom: none !important;
      justify-content: center !important;
      background: var(--bg-elevated, #f8fafc) !important;
      margin-top: 8px;
      border-radius: 8px;
    }
  }
`;

// ══════════════════════════════════════════════════════════════════════════════
// 1. KULLANICI YÖNETİMİ
// ══════════════════════════════════════════════════════════════════════════════
export function KullanicilarPage({ defaultRol = '' }) {
  const [users, setUsers] = useState([]);
  const [dersler, setDersler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rolFilter, setRolFilter] = useState(defaultRol);
  const [arama, setArama] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [pagination, setPagination] = useState({});
  const [sayfa, setSayfa] = useState(1);
  const [deleteModal, setDeleteModal] = useState({ open: false, user: null, loading: false });

  const [form, setForm] = useState({
    ad: '', soyad: '', email: '', telefon: '', sifre: 'Kullanici123!', rol: 'ogretmen', brans: ''
  });

  const ROLLER_LABEL = {
    kurucu: '👑 Kurucu', ogrenci_isleri: '🏫 Öğrenci İşleri',
    ogretmen: '📚 Öğretmen', rehber_ogretmen: '🧠 Rehber', muhasebe: '💰 Muhasebe',
    veli: '👨‍👩‍👦 Veli', ogrenci: '🎓 Öğrenci',
  };
  const ROLE_COLORS = {
    kurucu: '#F59E0B', ogrenci_isleri: '#10B981', ogretmen: '#3B82F6',
    rehber_ogretmen: '#8B5CF6', veli: '#EC4899', muhasebe: '#64748B',
    ogrenci: '#06B6D4',
  };

  useEffect(() => {
    axios.get('/dersler').then(res => {
      if (res.data.success) setDersler(res.data.data);
    }).catch(err => console.log('Dersler çekilemedi', err));
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ sayfa, limit: 20 });
      // defaultRol yerine kullanıcının tıkladığı rolFilter durumunu doğrudan gönderiyoruz
      if (rolFilter) params.append('rol', rolFilter);
      if (arama) params.append('arama', arama);
      const { data } = await axios.get(`/users?${params}`);
      if (data.success) { setUsers(data.data); setPagination(data.pagination || {}); }
    } catch { toast.error('Yükleme hatası'); }
    finally { setLoading(false); }
  }, [rolFilter, arama, sayfa]); // defaultRol bağımlılığını kaldırdık

  useEffect(() => {
    setRolFilter(defaultRol);
    setSayfa(1);
  }, [defaultRol]);

  useEffect(() => { load(); }, [load]);

  const handleCreate = async () => {
    if (!form.ad || !form.soyad || !form.email || !form.rol) {
      toast.error('Zorunlu alanları doldurun'); return;
    }
    if (form.rol === 'ogretmen' && !form.brans) {
      toast.error('Lütfen bir branş seçin!'); return;
    }
    try {
      await axios.post('/users', {
        ...form,
        extra: (form.rol === 'ogretmen' || form.rol === 'rehber_ogretmen')
          ? { brans: form.rol === 'rehber_ogretmen' ? 'Rehber Öğretmen' : form.brans }
          : {},
      });
      toast.success('Kullanıcı başarıyla oluşturuldu!');
      setShowModal(false);
      setForm({ ad: '', soyad: '', email: '', telefon: '', sifre: 'Kullanici123!', rol: 'ogretmen', brans: '' });
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'Hata'); }
  };

  const handleToggleAktif = async (user) => {
    await axios.put(`/users/${user.id}`, { ...user, aktif: user.aktif ? 0 : 1 });
    toast.success(user.aktif ? 'Kullanıcı pasife alındı' : 'Kullanıcı aktif edildi');
    load();
  };

  const handleSifreSifirla = async (userId) => {
    if (!window.confirm('Şifreyi sıfırlamak istiyor musunuz?')) return;
    await axios.put(`/users/${userId}/sifre-sifirla`, { yeni_sifre: 'Kullanici123!' });
    toast.success('Şifre sıfırlandı!');
  };

  const handleDelete = async () => {
    setDeleteModal(prev => ({ ...prev, loading: true }));
    try {
    await axios.delete(`/users/${deleteModal.user.id}/hard-delete`);
      toast.success('Kullanıcı kalıcı olarak silindi');
      setDeleteModal({ open: false, user: null, loading: false });
      load();
    } catch (e) {
      toast.error(e.response?.data?.message || 'Silme işlemi başarısız');
      setDeleteModal(prev => ({ ...prev, loading: false }));
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <style>{mobileStyles}</style>

      <DeleteConfirmModal
        isOpen={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, user: null, loading: false })}
        onConfirm={handleDelete}
        loading={deleteModal.loading}
        title="Kullanıcıyı Sil"
        message={`"${deleteModal.user?.ad} ${deleteModal.user?.soyad}" adlı kullanıcıyı kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz und kullanıcıya ait tüm veriler silinir.`}
      />

      <div className="section-header animate-fadeInUp mobile-section-header">
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.4rem', fontWeight: 800 }}>👥 Kullanıcı Yönetimi</h2>
          <div className="section-subtitle">Toplam {pagination.total || 0} kayıtlı kullanıcı</div>
        </div>
        <button className="btn btn-primary mobile-touch-btn" onClick={() => setShowModal(true)}>+ Yeni Kullanıcı</button>
      </div>

      <div className="card animate-fadeInUp stagger-1 mobile-p-sm" style={{ padding: '16px 20px' }}>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }} className="mobile-flex-col">
          <input
            className="form-input mobile-form-input"
            placeholder="🔍 Ad veya e-posta ile ara..."
            value={arama}
            onChange={e => { setArama(e.target.value); setSayfa(1); }}
            style={{ flex: 1, minWidth: 250 }}
          />
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }} className="mobile-chips">
            {/* Burada defaultRol kontrolünü kaldırarak her halükarda tüm rollerin listelenmesini sağladık */}
            {['', 'kurucu', 'ogrenci_isleri', 'muhasebe', 'ogretmen', 'rehber_ogretmen', 'veli', 'ogrenci'].map(r => (
              <button
                key={r}
                className={`chip ${rolFilter === r ? 'active' : ''}`}
                onClick={() => { setRolFilter(r); setSayfa(1); }}
              >
                {r ? ROLLER_LABEL[r] : 'Tümü'}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="card animate-fadeInUp stagger-2 mobile-p-0" style={{ padding: 0, overflow: 'hidden' }}>
        <div className="table-wrapper mobile-scroll-x">
          <table className="table mobile-table-card">
            <thead>
              <tr>
                <th>Kullanıcı</th>
                <th>Rol / Branş</th>
                <th>İletişim</th>
                <th>Durum</th>
                <th style={{ textAlign: 'right' }}>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {loading ? Array(5).fill(0).map((_, i) => (
                <tr key={i}>
                  <td colSpan={5}><div className="skeleton" style={{ height: 24 }} /></td>
                </tr>
              )) :
                users.length === 0 ? (
                  <tr>
                    <td colSpan={5}>
                      <div className="empty-state">
                        <div style={{ fontSize: '2rem' }}>🔍</div>
                        <h3>Kullanıcı bulunamadı</h3>
                        <p>Arama kriterlerinizi değiştirin veya yeni kullanıcı ekleyin.</p>
                      </div>
                    </td>
                  </tr>
                ) : users.map((u, i) => (
                  <tr key={i}>
                    <td data-label="Kullanıcı">
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div className="avatar avatar-sm" style={{ background: (ROLE_COLORS[u.rol] || '#94A3B8') + '20', color: ROLE_COLORS[u.rol] || '#94A3B8', fontWeight: 700 }}>
                          {u.ad?.[0]}{u.soyad?.[0]}
                        </div>
                        <div>
                          <div style={{ fontWeight: 600 }}>{u.ad} {u.soyad}</div>
                          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{u.email}</div>
                        </div>
                      </div>
                    </td>
                    <td data-label="Rol / Branş">
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <span style={{ color: ROLE_COLORS[u.rol], fontSize: '0.75rem', fontWeight: 700 }}>{ROLLER_LABEL[u.rol]}</span>
                        {u.brans && <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>📚 {u.brans}</span>}
                      </div>
                    </td>
                    <td data-label="İletişim">
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>{u.telefon || 'Belirtilmemiş'}</div>
                    </td>
                    <td data-label="Durum">
                      <span className={`badge ${u.aktif ? 'badge-success' : 'badge-danger'}`}>
                        {u.aktif ? 'Aktif' : 'Pasif'}
                      </span>
                    </td>
                    <td data-label="İşlem" style={{ textAlign: 'right' }}>
                      <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                        <button className="btn btn-ghost btn-sm mobile-touch-btn" onClick={() => handleSifreSifirla(u.id)} title="Şifre Sıfırla">🔄</button>
                        <button className={`btn btn-sm ${u.aktif ? 'btn-danger' : 'btn-success'} mobile-touch-btn`} onClick={() => handleToggleAktif(u)}>
                          {u.aktif ? 'Pasif' : 'Aktif'}
                        </button>
                        <button
                          className="btn btn-sm mobile-touch-btn"
                          onClick={() => setDeleteModal({ open: true, user: u, loading: false })}
                          title="Kalıcı Sil"
                          style={{ background: '#FEE2E2', color: '#EF4444', border: '1px solid #FECACA' }}
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {pagination.toplam_sayfa > 1 && (
          <div className="mobile-pagination" style={{ padding: '14px 16px', borderTop: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
              Sayfa {sayfa} / {pagination.toplam_sayfa} — Toplam {pagination.total} kullanıcı
            </span>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-ghost btn-sm mobile-touch-btn" disabled={sayfa === 1} onClick={() => setSayfa(s => s - 1)}>← Önceki</button>
              <button className="btn btn-ghost btn-sm mobile-touch-btn" disabled={sayfa >= pagination.toplam_sayfa} onClick={() => setSayfa(s => s + 1)}>Sonraki →</button>
            </div>
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-backdrop" onClick={() => setShowModal(false)}>
          <div className="modal mobile-modal-full" style={{ maxWidth: 600 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">👤 Yeni Kullanıcı</div>
              <button className="modal-close mobile-touch-btn" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }} className="mobile-p-sm">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }} className="mobile-grid-1">
                <div className="form-group">
                  <label className="form-label">Ad *</label>
                  <input className="form-input mobile-form-input" value={form.ad} onChange={e => setForm({ ...form, ad: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">Soyad *</label>
                  <input className="form-input mobile-form-input" value={form.soyad} onChange={e => setForm({ ...form, soyad: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">E-posta *</label>
                  <input className="form-input mobile-form-input" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                </div>
                <div className="form-group">
                  <label className="form-label">Telefon</label>
                  <input className="form-input mobile-form-input" value={form.telefon} onChange={e => setForm({ ...form, telefon: e.target.value })} />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Rol *</label>
                <select
                  className="form-select mobile-form-input"
                  value={form.rol}
                  onChange={e => {
                    const nextRol = e.target.value;
                    setForm({
                      ...form,
                      rol: nextRol,
                      brans: nextRol === 'rehber_ogretmen' ? 'Rehber Öğretmen' : nextRol === 'ogretmen' ? form.brans : '',
                    });
                  }}
                >
                  {Object.entries(ROLLER_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>
              {form.rol === 'ogretmen' && (
                <div style={{ background: 'rgba(59, 130, 246, 0.05)', padding: 14, borderRadius: 10, border: '1px solid #3B82F630' }}>
                  <div className="form-group">
                    <label className="form-label">Uzmanlık Branşı *</label>
                    <select className="form-select mobile-form-input" value={form.brans} onChange={e => setForm({ ...form, brans: e.target.value })} style={{ fontWeight: 600 }}>
                      <option value="">✓ Branş Seçin...</option>
                      {dersler.map(d => <option key={d.id} value={d.ad}>{d.ad}</option>)}
                    </select>
                  </div>
                </div>
              )}
              {form.rol === 'rehber_ogretmen' && (
                <div style={{ background: 'rgba(124, 58, 237, 0.06)', padding: 14, borderRadius: 10, border: '1px solid rgba(124, 58, 237, 0.18)' }}>
                  <div style={{ fontSize: '0.8rem', fontWeight: 700, color: 'var(--role-rehber)' }}>Uzmanlık alanı otomatik atanır</div>
                  <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 4 }}>
                    Rehber rolü için branş otomatik olarak <strong>Rehber Öğretmen</strong> seçilir.
                  </div>
                </div>
              )}
              <div className="form-group">
                <label className="form-label">Başlangıç Şifresi</label>
                <input className="form-input" value={form.sifre} disabled style={{ background: 'var(--bg-elevated)', color: 'var(--text-muted)' }} />
              </div>
              <button className="btn btn-primary btn-lg mobile-touch-btn" style={{ justifyContent: 'center', marginTop: 8 }} onClick={handleCreate}>✓ Kaydet ve Oluştur</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 2. DENEMELER & OPTİK KARNE SAYFASI
// ══════════════════════════════════════════════════════════════════════════════
export function DenemelerPage() {
  const [aktifSekme, setAktifSekme] = useState('karneler');
  const [sinavlar, setSinavlar] = useState([
    { id: 1, ad: 'Türkiye Geneli YKS Denemesi - 1', tarih: '2026-03-15', tur: 'Sayısal / EA', katilim: 142 },
    { id: 2, ad: 'Kurum İçi LGS Denemesi', tarih: '2026-03-10', tur: 'LGS', katilim: 56 },
  ]);
  const [seciliSinav, setSeciliSinav] = useState(1);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [deleteModal, setDeleteModal] = useState({ open: false, item: null, type: '', loading: false });

  const [sonuclar, setSonuclar] = useState([
    { id: 101, ad: 'Can', soyad: 'Doğan', numara: '1042', tip: 'kayitli', sinif: '11. Sınıf Sayısal - A', toplamNet: 82.5, puan: 412.5, siralama: 1 },
    { id: 102, ad: 'Ayşe', soyad: 'Yılmaz', numara: '9999', tip: 'misafir', sinif: 'Dışarıdan', toplamNet: 78.25, puan: 390.1, siralama: 2 },
    { id: 103, ad: 'Burak', soyad: 'Şahin', numara: '1055', tip: 'kayitli', sinif: '11. Sınıf Eşit Ağırlık - A', toplamNet: 65.0, puan: 345.0, siralama: 3 },
    { id: 104, ad: 'Mehmet', soyad: 'Kaya', numara: '8888', tip: 'misafir', sinif: 'Dışarıdan', toplamNet: 45.75, puan: 280.4, siralama: 4 },
  ]);

  const [arama, setArama] = useState('');
  const [seciliKarne, setSeciliKarne] = useState(null);

  const karneDetaylari = [
    { ders: 'Türkçe', soru: 40, dogru: 32, yanlis: 6, bos: 2, net: 30.5 },
    { ders: 'Matematik', soru: 40, dogru: 28, yanlis: 4, bos: 8, net: 27.0 },
    { ders: 'Fen Bilimleri', soru: 20, dogru: 15, yanlis: 4, bos: 1, net: 14.0 },
    { ders: 'Sosyal Bilgiler', soru: 20, dogru: 12, yanlis: 4, bos: 4, net: 11.0 },
  ];

  const handleOptikYukle = (e) => {
    e.preventDefault();
    setIsUploading(true);
    setUploadProgress(0);
    const interval = setInterval(() => {
      setUploadProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setIsUploading(false);
          toast.success('Optik sonuçlar başarıyla işlendi!');
          setAktifSekme('karneler');
          return 100;
        }
        return prev + 15;
      });
    }, 300);
  };

  const handleDeleteSinav = async () => {
    setDeleteModal(prev => ({ ...prev, loading: true }));
    try {
      await axios.delete(`/denemeler/${deleteModal.item.id}`);
      setSinavlar(prev => prev.filter(s => s.id !== deleteModal.item.id));
      toast.success('Sınav silindi');
      setDeleteModal({ open: false, item: null, type: '', loading: false });
    } catch (e) {
      toast.error(e.response?.data?.message || 'Silme başarısız');
      setDeleteModal(prev => ({ ...prev, loading: false }));
    }
  };

  const handleDeleteSonuc = async () => {
    setDeleteModal(prev => ({ ...prev, loading: true }));
    try {
      await axios.delete(`/deneme-sonuclari/${deleteModal.item.id}`);
      setSonuclar(prev => prev.filter(s => s.id !== deleteModal.item.id));
      toast.success('Sonuç silindi');
      setDeleteModal({ open: false, item: null, type: '', loading: false });
    } catch (e) {
      toast.error(e.response?.data?.message || 'Silme başarısız');
      setDeleteModal(prev => ({ ...prev, loading: false }));
    }
  };

  const filtrelenmisSonuclar = sonuclar.filter(s =>
    (s.ad + ' ' + s.soyad).toLowerCase().includes(arama.toLowerCase()) || s.numara.includes(arama)
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <style>{mobileStyles}</style>

      <DeleteConfirmModal
        isOpen={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, item: null, type: '', loading: false })}
        onConfirm={deleteModal.type === 'sinav' ? handleDeleteSinav : handleDeleteSonuc}
        loading={deleteModal.loading}
        title={deleteModal.type === 'sinav' ? 'Sınavı Sil' : 'Sonucu Sil'}
        message={
          deleteModal.type === 'sinav'
            ? `"${deleteModal.item?.ad}" sınavını ve tüm sonuçlarını kalıcı olarak silmek istiyor musunuz?`
            : `"${deleteModal.item?.ad} ${deleteModal.item?.soyad}" adlı öğrencinin bu sınav sonucunu silmek istiyor musunuz?`
        }
      />

      <div className="section-header animate-fadeInUp mobile-section-header">
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontWeight: 900, fontSize: '1.4rem' }}>📊 Deneme & Karne Yönetimi</h2>
          <div className="section-subtitle">Optik sonuçları yükleyin, karneleri oluşturun.</div>
        </div>
      </div>

      <div className="mobile-tabs" style={{ display: 'flex', background: 'var(--bg-elevated)', padding: 6, borderRadius: 12, gap: 8 }}>
        <button className={`btn ${aktifSekme === 'list' ? 'btn-primary' : 'btn-ghost'}`} style={{ flex: 1, justifyContent: 'center' }} onClick={() => setAktifSekme('list')}>📋 Deneme Sınavları</button>
        <button className={`btn ${aktifSekme === 'yukle' ? 'btn-primary' : 'btn-ghost'}`} style={{ flex: 1, justifyContent: 'center', background: aktifSekme === 'yukle' ? '#10B981' : '', color: aktifSekme === 'yukle' ? 'white' : '' }} onClick={() => setAktifSekme('yukle')}>📤 Optik / Dosya Yükle</button>
        <button className={`btn ${aktifSekme === 'karneler' ? 'btn-primary' : 'btn-ghost'}`} style={{ flex: 1, justifyContent: 'center', background: aktifSekme === 'karneler' ? 'linear-gradient(45deg, #3B82F6, #8B5CF6)' : '', color: aktifSekme === 'karneler' ? 'white' : '' }} onClick={() => setAktifSekme('karneler')}>📑 Karneler & Sonuçlar</button>
      </div>

      {aktifSekme === 'yukle' && (
        <div className="card animate-fadeInUp mobile-p-sm" style={{ padding: 40, textAlign: 'center' }}>
          <h3 style={{ marginBottom: 20 }}>Optik Okuyucu Sonuçlarını Yükle</h3>
          <p style={{ color: 'var(--text-muted)', marginBottom: 30, maxWidth: 500, margin: '0 auto 30px' }}>
            Optik okuyucudan aldığınız <strong>PDF, Excel veya DAT</strong> formatındaki sonuç dosyasını buraya yükleyin.
          </p>
          <div style={{ maxWidth: 400, margin: '0 auto' }}>
            <div className="form-group" style={{ textAlign: 'left', marginBottom: 20 }}>
              <label className="form-label">Sınav Seçin</label>
              <select className="form-select mobile-form-input" value={seciliSinav} onChange={e => setSeciliSinav(e.target.value)}>
                {sinavlar.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
              </select>
            </div>
            <div
              style={{ border: '2px dashed #3B82F6', borderRadius: 16, padding: '40px 20px', background: 'rgba(59, 130, 246, 0.05)', cursor: 'pointer' }}
              onClick={handleOptikYukle}
            >
              <div style={{ fontSize: '3rem', marginBottom: 10 }}>📄</div>
              <h4 style={{ color: '#3B82F6', margin: 0 }}>Dosyayı buraya sürükleyin</h4>
              <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginTop: 8 }}>veya seçmek için tıklayın</p>
            </div>
            {isUploading && (
              <div style={{ marginTop: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', marginBottom: 5 }}>
                  <span style={{ fontWeight: 700, color: '#3B82F6' }}>İşleniyor...</span>
                  <span>%{uploadProgress}</span>
                </div>
                <div className="progress-bar" style={{ height: 8, borderRadius: 4 }}>
                  <div className="progress-fill" style={{ width: `${uploadProgress}%`, background: '#3B82F6', transition: 'width 0.3s ease' }} />
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {aktifSekme === 'karneler' && (
        <div className="card animate-fadeInUp mobile-p-sm">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 20, flexWrap: 'wrap', gap: 10 }} className="mobile-flex-col">
            <div style={{ flex: 1, minWidth: 250 }}>
              <label className="form-label">Sınav Seçin</label>
              <select className="form-select mobile-form-input" value={seciliSinav} onChange={e => setSeciliSinav(e.target.value)}>
                {sinavlar.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
              </select>
            </div>
            <div style={{ flex: 1, minWidth: 250 }}>
              <label className="form-label">Öğrenci Ara</label>
              <input className="form-input mobile-form-input" placeholder="İsim veya numara..." value={arama} onChange={e => setArama(e.target.value)} />
            </div>
          </div>

          <div className="table-wrapper mobile-scroll-x">
            <table className="table mobile-table-card" style={{ fontSize: '0.9rem' }}>
              <thead>
                <tr>
                  <th style={{ width: 60, textAlign: 'center' }}>Sıra</th>
                  <th>Öğrenci Bilgisi</th>
                  <th>Kayıt Tipi</th>
                  <th>Toplam Net</th>
                  <th>Puan</th>
                  <th style={{ textAlign: 'right' }}>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {filtrelenmisSonuclar.map((s) => (
                  <tr key={s.id}>
                    <td data-label="Sıra" style={{ textAlign: 'center', fontWeight: 800, color: 'var(--text-muted)' }}>#{s.siralama}</td>
                    <td data-label="Öğrenci">
                      <div style={{ fontWeight: 700 }}>{s.ad} {s.soyad}</div>
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>No: {s.numara} • {s.sinif}</div>
                    </td>
                    <td data-label="Kayıt Tipi">
                      <span className={`badge ${s.tip === 'kayitli' ? 'badge-success' : 'badge-warning'}`}>
                        {s.tip === 'kayitli' ? '🏫 Kurum' : '🌍 Misafir'}
                      </span>
                    </td>
                    <td data-label="Toplam Net" style={{ fontWeight: 800, color: '#3B82F6', fontSize: '1.1rem' }}>{s.toplamNet}</td>
                    <td data-label="Puan" style={{ fontWeight: 800 }}>{s.puan}</td>
                    <td data-label="İşlem" style={{ textAlign: 'right' }}>
                      <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                        <button className="btn btn-outline btn-sm mobile-touch-btn" style={{ borderColor: '#8B5CF6', color: '#8B5CF6' }} onClick={() => setSeciliKarne(s)}>📄 Karne</button>
                        <button
                          className="btn btn-sm mobile-touch-btn"
                          style={{ background: '#FEE2E2', color: '#EF4444', border: '1px solid #FECACA' }}
                          onClick={() => setDeleteModal({ open: true, item: s, type: 'sonuc', loading: false })}
                          title="Sonucu Sil"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {aktifSekme === 'list' && (
        <div className="card animate-fadeInUp mobile-p-sm">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }} className="mobile-flex-col">
            <h3 style={{ margin: 0 }}>Tanımlı Sınavlar</h3>
            <button className="btn btn-primary mobile-touch-btn">+ Yeni Sınav Tanımla</button>
          </div>
          <div className="table-wrapper mobile-scroll-x">
            <table className="table mobile-table-card">
              <thead>
                <tr>
                  <th>Sınav Adı</th>
                  <th>Tarih</th>
                  <th>Türü</th>
                  <th>Katılım</th>
                  <th style={{ textAlign: 'right' }}>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {sinavlar.map(s => (
                  <tr key={s.id}>
                    <td data-label="Sınav" style={{ fontWeight: 700 }}>{s.ad}</td>
                    <td data-label="Tarih">{new Date(s.tarih).toLocaleDateString('tr-TR')}</td>
                    <td data-label="Türü"><span className="badge badge-info">{s.tur}</span></td>
                    <td data-label="Katılım">{s.katilim} Öğrenci</td>
                    <td data-label="İşlem" style={{ textAlign: 'right' }}>
                      <button
                        className="btn btn-sm mobile-touch-btn"
                        style={{ background: '#FEE2E2', color: '#EF4444', border: '1px solid #FECACA' }}
                        onClick={() => setDeleteModal({ open: true, item: s, type: 'sinav', loading: false })}
                        title="Sınavı Sil"
                      >
                        🗑️ Sil
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {seciliKarne && (
        <div className="modal-backdrop" onClick={() => setSeciliKarne(null)}>
          <div className="modal mobile-modal-full" style={{ maxWidth: 800, padding: 0, overflow: 'hidden' }} onClick={e => e.stopPropagation()}>
            <div style={{ background: '#1E293B', color: 'white', padding: '30px 40px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }} className="mobile-flex-col">
                <div>
                  <h2 style={{ fontFamily: 'var(--font-ui)', margin: '0 0 5px 0', fontSize: '1.8rem' }}>DERSHANE PRO</h2>
                  <p style={{ margin: 0, color: '#94A3B8', fontSize: '0.9rem' }}>Bireysel Deneme Sınavı Sonuç Karnesi</p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <h3 style={{ margin: '0 0 5px 0', color: '#38BDF8' }}>{sinavlar.find(s => s.id.toString() === seciliSinav.toString())?.ad}</h3>
                  <p style={{ margin: 0, fontSize: '0.85rem' }}>{new Date().toLocaleDateString('tr-TR')}</p>
                </div>
              </div>
            </div>
            <div style={{ padding: '20px 40px', background: '#F8FAFC', borderBottom: '1px solid var(--border)', display: 'flex', gap: 40 }}>
              <div style={{ flex: 2 }}>
                <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>Öğrenci Adı Soyadı</div>
                <div style={{ fontSize: '1.3rem', fontWeight: 800, color: '#0F172A' }}>{seciliKarne.ad} {seciliKarne.soyad}</div>
              </div>
              <div style={{ flex: 3, display: 'flex', gap: 15 }}>
                {[['TOPLAM NET', seciliKarne.toplamNet, '#3B82F6'], ['PUAN', seciliKarne.puan, '#10B981'], ['SIRA', `#${seciliKarne.siralama}`, '#F59E0B']].map(([l, v, c]) => (
                  <div key={l} style={{ flex: 1, background: 'white', padding: 15, borderRadius: 12, border: '1px solid var(--border)', textAlign: 'center' }}>
                    <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', fontWeight: 700 }}>{l}</div>
                    <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.6rem', fontWeight: 900, color: c }}>{v}</div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ padding: '30px 40px' }}>
              <h4 style={{ marginBottom: 15 }}>Ders Bazlı Performans</h4>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center', fontSize: '0.9rem' }}>
                <thead>
                  <tr style={{ background: '#F1F5F9', borderTop: '2px solid #CBD5E1', borderBottom: '2px solid #CBD5E1' }}>
                    {['Ders', 'Soru', 'Doğru', 'Yanlış', 'Boş', 'Net'].map(h => (
                      <th key={h} style={{ padding: 12, textAlign: h === 'Ders' ? 'left' : 'center', color: '#475569' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {karneDetaylari.map((k, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #E2E8F0' }}>
                      <td style={{ padding: '14px 12px', textAlign: 'left', fontWeight: 700 }}>{k.ders}</td>
                      <td style={{ padding: 12 }}>{k.soru}</td>
                      <td style={{ padding: 12, fontWeight: 700, color: '#10B981' }}>{k.dogru}</td>
                      <td style={{ padding: 12, fontWeight: 700, color: '#EF4444' }}>{k.yanlis}</td>
                      <td style={{ padding: 12, color: '#94A3B8' }}>{k.bos}</td>
                      <td style={{ padding: 12, fontWeight: 900, color: '#3B82F6' }}>{k.net}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 24 }}>
                <button className="btn btn-outline mobile-touch-btn" onClick={() => setSeciliKarne(null)}>Kapat</button>
                <button className="btn btn-primary mobile-touch-btn" style={{ background: '#1E293B', border: 'none' }} onClick={() => toast.success('PDF indiriliyor...')}>📥 PDF İndir</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 3. BİLDİRİMLER
// ══════════════════════════════════════════════════════════════════════════════
export function BildirimlerPage() {
  const [users, setUsers] = useState([]);
  const [bildirimler, setBildirimler] = useState([]);
  const [loadingB, setLoadingB] = useState(true);
  const [form, setForm] = useState({ baslik: '', mesaj: '', tur: 'bilgi', hedef: 'rol', alici_rol: 'ogrenci', alici_ids: [] });
  const [secili, setSecili] = useState([]);
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [deleteModal, setDeleteModal] = useState({ open: false, item: null, loading: false });

  const TURLER = [{ k: 'bilgi', l: '💬 Bilgi', c: '#3B82F6' }, { k: 'uyari', l: '⚠️ Uyarı', c: '#F97316' }, { k: 'basari', l: '🏆 Başarı', c: '#10B981' }];
  const ROLLER = ['ogrenci', 'ogretmen', 'rehber_ogretmen', 'veli', 'ogrenci_isleri'];
  const TUR_ICONS = { bilgi: '💬', uyari: '⚠️', basari: '🏆', devamsizlik: '📢', odev: '📝', deneme: '📊', sistem: '🔧' };

  const loadBildirimler = async () => {
    const bRes = await axios.get('/bildirimler?limit=20');
    if (bRes.data.success) setBildirimler(bRes.data.data);
  };

  useEffect(() => {
    Promise.all([axios.get('/users?limit=100'), axios.get('/bildirimler?limit=20')])
      .then(([uRes, bRes]) => {
        if (uRes.data.success) setUsers(uRes.data.data);
        if (bRes.data.success) setBildirimler(bRes.data.data);
      }).finally(() => setLoadingB(false));
  }, []);

  const handleGonder = async () => {
    if (!form.baslik || !form.mesaj) { toast.error('Başlık ve mesaj zorunlu'); return; }
    setGonderiliyor(true);
    try {
      const payload = { baslik: form.baslik, mesaj: form.mesaj, tur: form.tur };
      if (form.hedef === 'rol') payload.alici_rol = form.alici_rol; else payload.alici_ids = secili;
      await axios.post('/bildirimler/gonder', payload);
      toast.success('Bildirim gönderildi!');
      setForm({ baslik: '', mesaj: '', tur: 'bilgi', hedef: 'rol', alici_rol: 'ogrenci', alici_ids: [] });
      setSecili([]);
      await loadBildirimler();
    } catch { toast.error('Gönderim başarısız'); }
    finally { setGonderiliyor(false); }
  };

  const handleDeleteBildirim = async () => {
    setDeleteModal(prev => ({ ...prev, loading: true }));
    try {
      await axios.delete(`/bildirimler/${deleteModal.item.id}`);
      setBildirimler(prev => prev.filter(b => b.id !== deleteModal.item.id));
      toast.success('Bildirim silindi');
      setDeleteModal({ open: false, item: null, loading: false });
    } catch (e) {
      toast.error(e.response?.data?.message || 'Silme başarısız');
      setDeleteModal(prev => ({ ...prev, loading: false }));
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <style>{mobileStyles}</style>

      <DeleteConfirmModal
        isOpen={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, item: null, loading: false })}
        onConfirm={handleDeleteBildirim}
        loading={deleteModal.loading}
        title="Bildirimi Sil"
        message={`"${deleteModal.item?.baslik}" başlıklı bildirimi kalıcı olarak silmek istiyor musunuz?`}
      />

      <div className="animate-fadeInUp"><h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>🔔 Bildirim Yönetimi</h2></div>
      <div className="grid-2 animate-fadeInUp stagger-1 mobile-grid-1">
        <div className="card mobile-p-sm">
          <div className="section-title" style={{ marginBottom: 16 }}>📤 Bildirim Gönder</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div className="form-group">
              <label className="form-label">Bildirim Türü</label>
              <div style={{ display: 'flex', gap: 8 }} className="mobile-chips">
                {TURLER.map(t => (
                  <button key={t.k} style={{ flex: 1, padding: '8px', borderRadius: 8, cursor: 'pointer', background: form.tur === t.k ? t.c + '20' : 'var(--bg-elevated)', border: `1px solid ${form.tur === t.k ? t.c + '50' : 'var(--border)'}`, color: form.tur === t.k ? t.c : 'var(--text-secondary)', fontSize: '0.8rem', fontWeight: 600 }} onClick={() => setForm({ ...form, tur: t.k })}>
                    {t.l}
                  </button>
                ))}
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Hedef Kitle</label>
              <div style={{ display: 'flex', gap: 8 }}>
                {[{ k: 'rol', l: 'Rol Bazlı' }, { k: 'bireysel', l: 'Bireysel' }].map(h => (
                  <button key={h.k} className={`chip ${form.hedef === h.k ? 'active' : ''}`} onClick={() => setForm({ ...form, hedef: h.k })}>{h.l}</button>
                ))}
              </div>
            </div>
            {form.hedef === 'rol' ? (
              <div className="form-group">
                <label className="form-label">Rol Seç</label>
                <select className="form-select mobile-form-input" value={form.alici_rol} onChange={e => setForm({ ...form, alici_rol: e.target.value })}>
                  {ROLLER.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              </div>
            ) : (
              <div className="form-group">
                <label className="form-label">Kullanıcı Seç ({secili.length} seçili)</label>
                <div style={{ maxHeight: 160, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 10, padding: 8 }}>
                  {users.map(u => (
                    <label key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 6px', cursor: 'pointer', borderRadius: 6, minHeight: 44 }}>
                      <input type="checkbox" checked={secili.includes(u.id)} onChange={e => setSecili(prev => e.target.checked ? [...prev, u.id] : prev.filter(id => id !== u.id))} />
                      <span style={{ fontSize: '0.82rem' }}>{u.ad} {u.soyad} ({u.rol})</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            <div className="form-group">
              <label className="form-label">Başlık *</label>
              <input className="form-input" value={form.baslik} onChange={e => setForm({ ...form, baslik: e.target.value })} placeholder="Bildirim başlığı" />
            </div>
            <div className="form-group">
              <label className="form-label">Mesaj *</label>
              <textarea className="form-textarea" value={form.mesaj} onChange={e => setForm({ ...form, mesaj: e.target.value })} placeholder="Bildirim içeriği..." style={{ minHeight: 80 }} />
            </div>
            <button className="btn btn-primary" onClick={handleGonder} disabled={gonderiliyor} style={{ justifyContent: 'center' }}>
              {gonderiliyor ? 'Gönderiliyor...' : '📤 Gönder'}
            </button>
          </div>
        </div>

        <div className="card mobile-p-sm">
          <div className="section-title" style={{ marginBottom: 16 }}>📋 Son Bildirimler</div>
          {loadingB ? <div className="page-loader"><div className="spinner" /></div> :
            bildirimler.length === 0 ? <div className="empty-state"><p>Bildirim yok</p></div> :
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxHeight: 480, overflowY: 'auto' }}>
                {bildirimler.map((b, i) => (
                  <div key={i} style={{ padding: '10px 12px', background: b.okundu ? 'var(--bg-elevated)' : 'rgba(245,158,11,0.04)', border: `1px solid ${b.okundu ? 'var(--border)' : 'rgba(245,158,11,0.15)'}`, borderRadius: 10, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                    <span style={{ fontSize: '1.1rem', flexShrink: 0 }}>{TUR_ICONS[b.tur] || '💬'}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 600, fontSize: '0.82rem' }}>{b.baslik}</div>
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.mesaj}</div>
                      <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginTop: 4 }}>{new Date(b.created_at).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}</div>
                    </div>
                    <button
                      className="btn btn-ghost btn-sm"
                      style={{ color: '#EF4444', padding: '4px 8px', flexShrink: 0 }}
                      onClick={() => setDeleteModal({ open: true, item: b, loading: false })}
                      title="Sil"
                    >
                      🗑️
                    </button>
                  </div>
                ))}
              </div>
          }
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 4. TOPLU MESAJ
// ══════════════════════════════════════════════════════════════════════════════
export function TopluMesajPage() {
  const ALICI_GRUPLARI = [
    { label: 'Öğrenciler', roller: ['ogrenci'] },
    { label: 'Veliler', roller: ['veli'] },
    { label: 'Öğretmenler', roller: ['ogretmen', 'rehber_ogretmen'] },
    { label: 'Öğrenci İşleri', roller: ['ogrenci_isleri'] },
    { label: 'Muhasebe', roller: ['muhasebe'] },
    { label: 'Kurucu / Admin', roller: ['kurucu'] },
  ];

  const TUM_ROLLER = ALICI_GRUPLARI.flatMap(grup => grup.roller);
  const ROL_LABELS = {
    kurucu: 'Kurucu / Admin', ogrenci_isleri: 'Öğrenci İşleri', ogretmen: 'Öğretmen',
    rehber_ogretmen: 'Rehber Öğretmen', veli: 'Veli', ogrenci: 'Öğrenci', muhasebe: 'Muhasebe',
  };

  const [topluMesaj, setTopluMesaj] = useState('');
  const [hedefTipi, setHedefTipi] = useState('grup');
  const [seciliRoller, setSeciliRoller] = useState(TUM_ROLLER);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [seciliKullaniciIds, setSeciliKullaniciIds] = useState([]);
  const [kullaniciArama, setKullaniciArama] = useState('');
  const [whatsAppGonderiliyor, setWhatsAppGonderiliyor] = useState(false);
  const [whatsAppOzet, setWhatsAppOzet] = useState(null);

  useEffect(() => {
    setUsersLoading(true);
    axios.get('/users?limit=500')
      .then(res => {
        if (res.data.success) setUsers((res.data.data || []).filter(u => u.aktif !== 0 && u.telefon));
      })
      .catch(() => toast.error('Kullanıcı listesi yüklenemedi'))
      .finally(() => setUsersLoading(false));
  }, []);

  const toggleAliciGrubu = (roller) => {
    setSeciliRoller(prev => {
      const grupSecili = roller.every(rol => prev.includes(rol));
      if (grupSecili) return prev.filter(rol => !roller.includes(rol));
      return Array.from(new Set([...prev, ...roller]));
    });
  };

  const handleTopluWhatsappGonder = async () => {
    if (!topluMesaj.trim()) { toast.error('Mesaj zorunlu'); return; }
    if (hedefTipi === 'grup' && seciliRoller.length === 0) { toast.error('En az bir alıcı grubu seçin'); return; }
    if (hedefTipi === 'bireysel' && seciliKullaniciIds.length === 0) { toast.error('En az bir kullanıcı seçin'); return; }

    setWhatsAppGonderiliyor(true);
    try {
      const payload = hedefTipi === 'grup'
        ? { mesaj: topluMesaj.trim(), roller: seciliRoller }
        : { mesaj: topluMesaj.trim(), alici_ids: seciliKullaniciIds };
      const { data } = await axios.post('/bildirimler/toplu-whatsapp', payload);
      if (data.success) {
        setWhatsAppOzet(data.ozet || null);
        toast.success(data.message || 'Toplu mesaj gönderildi');
        setTopluMesaj('');
        if (hedefTipi === 'bireysel') setSeciliKullaniciIds([]);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Toplu mesaj gönderilemedi');
    } finally {
      setWhatsAppGonderiliyor(false);
    }
  };

  const filtreliUsers = users.filter(u => {
    const arama = kullaniciArama.trim().toLocaleLowerCase('tr-TR');
    if (!arama) return true;
    const metin = `${u.ad || ''} ${u.soyad || ''} ${u.email || ''} ${u.telefon || ''} ${ROL_LABELS[u.rol] || u.rol || ''}`.toLocaleLowerCase('tr-TR');
    return metin.includes(arama);
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <style>{mobileStyles}</style>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>📱 Toplu Mesaj Gönder</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 4 }}>Seçtiğiniz alıcı gruplarına WhatsApp mesajı gönderin.</p>
      </div>
      <div className="card animate-fadeInUp stagger-1 mobile-p-sm">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="form-group">
            <label className="form-label">Gönderim Türü</label>
            <div style={{ display: 'flex', gap: 8 }}>
              {[{ key: 'grup', label: 'Grup Bazlı' }, { key: 'bireysel', label: 'Bireysel Seçim' }].map(tip => (
                <button key={tip.key} className={`btn ${hedefTipi === tip.key ? 'btn-primary' : 'btn-outline'}`} onClick={() => setHedefTipi(tip.key)}>
                  {hedefTipi === tip.key ? `✓ ${tip.label}` : tip.label}
                </button>
              ))}
            </div>
          </div>
          {hedefTipi === 'grup' ? (
            <div className="form-group">
              <label className="form-label">Alıcı Grupları *</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {ALICI_GRUPLARI.map(grup => {
                  const secili = grup.roller.every(rol => seciliRoller.includes(rol));
                  return (
                    <button key={grup.label} className={`btn ${secili ? 'btn-primary' : 'btn-outline'}`} onClick={() => toggleAliciGrubu(grup.roller)} style={{ background: secili ? 'linear-gradient(45deg, #10B981, #059669)' : undefined, borderColor: secili ? '#10B981' : undefined }}>
                      {secili ? `✓ ${grup.label}` : grup.label}
                    </button>
                  );
                })}
                <button className="btn btn-ghost" onClick={() => setSeciliRoller(TUM_ROLLER)}>Tümünü Seç</button>
              </div>
            </div>
          ) : (
            <div className="form-group">
              <label className="form-label">Kullanıcı Seç ({seciliKullaniciIds.length} seçili)</label>
              <input className="form-input" value={kullaniciArama} onChange={e => setKullaniciArama(e.target.value)} placeholder="Ad, e-posta veya telefon ile ara..." style={{ marginBottom: 10 }} />
              <div style={{ maxHeight: 260, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 10, padding: 8 }}>
                {usersLoading ? <div className="page-loader" style={{ minHeight: 120 }}><div className="spinner" /></div> :
                  filtreliUsers.map(u => (
                    <label key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 8px', cursor: 'pointer', borderRadius: 8, minHeight: 46, borderBottom: '1px solid var(--border)' }}>
                      <input type="checkbox" checked={seciliKullaniciIds.includes(u.id)} onChange={() => setSeciliKullaniciIds(prev => prev.includes(u.id) ? prev.filter(id => id !== u.id) : [...prev, u.id])} />
                      <span style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <span style={{ fontSize: '0.84rem', fontWeight: 700 }}>{u.ad} {u.soyad}</span>
                        <span style={{ fontSize: '0.74rem', color: 'var(--text-muted)' }}>{ROL_LABELS[u.rol] || u.rol} · {u.telefon}</span>
                      </span>
                    </label>
                  ))}
              </div>
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Mesaj *</label>
            <textarea className="form-textarea" value={topluMesaj} onChange={e => setTopluMesaj(e.target.value)} placeholder="Mesaj..." style={{ minHeight: 160 }} />
          </div>
          <button className="btn btn-primary" onClick={handleTopluWhatsappGonder} disabled={whatsAppGonderiliyor} style={{ justifyContent: 'center', background: 'linear-gradient(45deg, #10B981, #059669)', border: 'none' }}>
            {whatsAppGonderiliyor ? 'Gönderiliyor...' : '📱 Toplu Mesaj Gönder'}
          </button>
        </div>
      </div>
      {whatsAppOzet && (
        <div className="card animate-fadeInUp stagger-2 mobile-p-sm">
          <div className="section-title" style={{ marginBottom: 16 }}>📊 Gönderim Özeti</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10 }}>
            {[['Toplam Kayıt', whatsAppOzet.toplam_kayit], ['Benzersiz Numara', whatsAppOzet.benzersiz_numara], ['Gönderilen', whatsAppOzet.gonderilen], ['Atlanan', whatsAppOzet.atlanan], ['Başarısız', whatsAppOzet.basarisiz]].map(([label, value]) => (
              <div key={label} style={{ padding: '12px 14px', borderRadius: 12, border: '1px solid var(--border)', background: 'var(--bg-elevated)' }}>
                <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: 4 }}>{label}</div>
                <div style={{ fontWeight: 800, fontSize: '1rem' }}>{value ?? 0}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 5. SİSTEM ANALİZİ
// ══════════════════════════════════════════════════════════════════════════════
export function SistemAnalizPage() {
  const [analiz, setAnaliz] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/admin/sistem-analiz').then(res => { if (res.data.success) setAnaliz(res.data.data); }).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-loader"><div className="spinner" /></div>;

  const dusen = analiz?.dusus_trendi || [];
  const devamsiz = analiz?.devamsizlik_artis || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <style>{mobileStyles}</style>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>🤖 Sistem Analizi</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 4 }}>Yapay zeka destekli otomatik uyarı ve öneriler</p>
      </div>

      <div className="card animate-fadeInUp stagger-1 mobile-p-sm">
        <div className="section-header mobile-flex-col">
          <div className="section-title">📉 Düşüş Trendi Uyarıları</div>
          <span className="badge badge-danger">{dusen.length}</span>
        </div>
        {dusen.length === 0 ? <div className="alert alert-success">🎉 Tüm öğrenciler yükselişte!</div> :
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {dusen.map((o, i) => (
              <div key={i} style={{ padding: '14px 16px', background: 'var(--danger-dim)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 12, display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: '1.2rem' }}>⚠️</span>
                <div>
                  <div style={{ fontWeight: 700, color: '#EF4444' }}>{o.ad}</div>
                  <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>{o.mesaj}</div>
                </div>
              </div>
            ))}
          </div>
        }
      </div>

      <div className="card animate-fadeInUp stagger-2 mobile-p-sm">
        <div className="section-header mobile-flex-col">
          <div className="section-title">📢 Devamsızlık Artışı</div>
          <span className="badge badge-warning">{devamsiz.length}</span>
        </div>
        {devamsiz.length === 0 ? <div className="alert alert-success">✅ Devamsızlık sorunu yok.</div> :
          <div className="table-wrapper mobile-scroll-x">
            <table className="table mobile-table-card">
              <thead>
                <tr>
                  <th>Öğrenci</th>
                  <th>Devamsızlık</th>
                </tr>
              </thead>
              <tbody>
                {devamsiz.map((o, i) => (
                  <tr key={i}>
                    <td data-label="Öğrenci" style={{ fontWeight: 600 }}>{o.ad} {o.soyad}</td>
                    <td data-label="Devamsızlık"><span style={{ fontWeight: 800, color: '#EF4444' }}>{o.devamsizlik_sayisi}</span> gün</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  );
}